import { render, staticRenderFns } from "./privacy-main.vue?vue&type=template&id=bcd40dca&lang=pug&"
import script from "./privacy-main.vue?vue&type=script&lang=js&"
export * from "./privacy-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports